var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCraEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90025 12.5138C5.49395 12.5138 3.19263 11.0187 1.05786 8.0676V8.0677C0.983253 7.96476 0.980605 7.82646 1.05103 7.72076C1.16742 7.54567 3.94923 3.42982 7.96021 3.33537C10.4177 3.27055 12.7646 4.74888 14.9409 7.70902H14.9408C15.0161 7.81135 15.0199 7.94955 14.9504 8.05585C14.8339 8.2339 12.0511 12.4178 8.03727 12.5122C7.99171 12.5132 7.94605 12.5138 7.9006 12.5138L7.90025 12.5138ZM1.67987 7.88678C3.69183 10.6026 5.82888 11.9549 8.02001 11.9038C11.2725 11.829 13.7559 8.67395 14.32 7.89461C12.3075 5.2221 10.1686 3.8985 7.97722 3.9439C4.72705 4.01881 2.24605 7.11762 1.67987 7.88678Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 10.4257C7.33635 10.4257 6.69999 10.1621 6.23084 9.69292C5.76162 9.2238 5.49805 8.58741 5.49805 7.92392C5.49805 7.26042 5.76162 6.62406 6.23084 6.15491C6.69996 5.68569 7.33635 5.42212 7.99984 5.42212C8.66334 5.42212 9.2997 5.68569 9.76885 6.15491C10.2381 6.62403 10.5016 7.26042 10.5016 7.92392C10.5008 8.5872 10.2371 9.22307 9.76804 9.69211C9.299 10.1612 8.66313 10.4249 7.99984 10.4257ZM7.99984 6.03093C7.4978 6.03093 7.01634 6.23028 6.66134 6.58536C6.30627 6.94033 6.10691 7.42182 6.10691 7.92386C6.10691 8.42591 6.30626 8.90737 6.66134 9.26236C7.01631 9.61744 7.4978 9.8168 7.99984 9.8168C8.50189 9.8168 8.98335 9.61745 9.33834 9.26236C9.69342 8.90739 9.89278 8.42591 9.89278 7.92386C9.89227 7.42203 9.69261 6.94086 9.33774 6.58599C8.98285 6.2311 8.50171 6.03145 7.99987 6.03096L7.99984 6.03093Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraEye);
export default __webpack_public_path__ + "static/media/cra-eye.7726c058ca8e09d43c1deab0b8ecde88.svg";
export { ForwardRef as ReactComponent };